export const addOpacityToColor = (color, opacity = 1) => {

  // Check if the color is in rgb/rgba format
  if (color.startsWith('rgb')) {
    // Extract the RGB values
    const rgba = color.replace(/[^\d,.]/g, '').split(',');
    return `rgba(${rgba[0]}, ${rgba[1]}, ${rgba[2]}, ${opacity})`;
  } else if (color.startsWith('#')) {
    // If the color is in hex format, convert it to RGB first
    const hex = color.replace('#', '');
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  } else {
    console.warn('Unsupported color format');
    return color;
  }
};
